import { pagesLinks } from "../common/links"

export default {
	header: "Мобильное\nприложение\nдля ваших гостей",
	description:
		"Предоставим специалиста\nпо внедрению и 3 месяца подписки в\nподарок",
	backLink: pagesLinks.indexWL,
}
